import React from 'react';

import { Tooltip } from 'antd-v5';
import {
  MdAutorenew,
  MdCancel,
  MdCheckCircle,
  MdError,
  MdOutlineInsertDriveFile,
} from 'react-icons/md';
import { FormattedMessage } from 'react-intl';
import { DarkToolbarButton } from 'scouting-ui/lib/Button';
import type { ButtonProps } from 'scouting-ui/lib/Button/Button';

import type { CampImportStatus } from '@modules/advancement/advancementImport/hooks';
import type { ImportButtonState } from '@modules/advancement/advancementImport/types';
import { getImportButtonState } from '@modules/advancement/advancementImport/utils';

import styles from './RosterImportButton.module.scss';

const STATE_PROPS: Record<
  ImportButtonState,
  Pick<ButtonProps, 'color' | 'variant' | 'icon'> & { labelId: string }
> = {
  idle: {
    icon: <MdOutlineInsertDriveFile />,
    labelId: 'rosterV2.table.import',
  },
  working: {
    icon: <MdAutorenew className={styles.importSpinner} />,
    labelId: 'rosterV2.table.import',
  },
  needsReview: {
    color: 'danger',
    variant: 'solid',
    icon: <MdError />,
    labelId: 'rosterV2.table.import.needsReview',
  },
  done: {
    color: 'green',
    variant: 'solid',
    icon: <MdCheckCircle />,
    labelId: 'rosterV2.table.import.done',
  },
  error: {
    color: 'danger',
    variant: 'solid',
    icon: <MdCancel />,
    labelId: 'rosterV2.table.import.error',
  },
};

interface RosterImportButtonProps {
  campImport: Pick<CampImportStatus, 'view' | 'isWorking' | 'needsAction'>;
  onClick: () => void;
}

const RosterImportButton: React.FC<RosterImportButtonProps> = props => {
  const { campImport, onClick } = props;

  const { labelId, ...buttonProps } =
    STATE_PROPS[getImportButtonState(campImport)];

  return (
    <Tooltip
      title={
        campImport.view && (
          <FormattedMessage
            id="rosterV2.table.import.status"
            values={{ status: campImport.view.processStatus }}
          />
        )
      }
    >
      <DarkToolbarButton {...buttonProps} onClick={onClick}>
        <FormattedMessage id={labelId} />
      </DarkToolbarButton>
    </Tooltip>
  );
};

export default RosterImportButton;
